import React, { useEffect, useState } from "react";
import {
  capitalize,
  dateForHumans,
  numberWithCommas,
  timeAmPm,
} from "../../utils";
import FunnelSimple from "../../assets/svg/FunnelSimple.svg";
import TransferModal from "./modal/TransferModal";
import { clearObj } from "../../features/obj/objSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchFundsTransfer,
  fetchSettlement,
} from "../../features/fetch/fetchSlice";
import FilterModal from "./modal/FilterModal";
import BreadCrumb from "../../layout/BreadCrumb";
import flash from "../../assets/svg/Flash.svg";
import useModalToggle from "../../custom_hooks/useModalToggle";
import svg38 from "../../assets/svg/svg38.svg";
import svg32 from "../../assets/svg/svg32.svg";
import svg67 from "../../assets/svg/svg67.svg";
import { Spin, Table, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import ConfirmSubmitModal from "../../components/ConfirmSubmitModal";
import toast from "react-hot-toast";
import { save } from "../../features/save/saveSlice";
import MaterialIcon from "material-icons-react";
import { downloadExcel } from "../../features/global/globalSlice";
import CardLoading from "../../components/CardLoading";

function FundsTransferList() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { open, handleCancel, handleOpen } = useModalToggle();

  const { fundsTransferCount, fundsTransfer, loading } = useSelector(
    (state) => state.fetch
  );
  const { saving } = useSelector((state) => state.save);
  const { glbLoading } = useSelector((state) => state.global);

  const [filters, setFilters] = useState([]);
  const [formData, setFormData] = useState({});
  const showModalFilter = () => {
    handleOpen();
  };

  const handleClearFilters = async () => {
    await setFormData({});
    await setFilters([]);
    await dispatch(
      fetchFundsTransfer({
        url: "api/v1/wallet/fetch-fund-transfers",
        ftSourceWallet: null,
      })
    );
  };

  const [prodd, setProdd] = useState("");

  const [isModalOpenSubmit, setIsModalOpenSubmit] = useState(false);

  const handleConfirmation = async (item) => {
    await setProdd(item);
    await setIsModalOpenSubmit(true);
  };

  const handleCancelConfirmation = async () => {
    await setIsModalOpenSubmit(false);
  };
  const handleSubmit = async () => {
    const res = await dispatch(
      save({
        url: `api/v1/wallet/retry-funds-transfer/${prodd?.ftId}`,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res.payload?.messages?.message);
      await setIsModalOpenSubmit(false);
      await setProdd();
      await fetchFundsTransferData();
    } else {
      toast.error(res.payload?.messages?.message);
    }
  };

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [openTransfer, setOpenTransfer] = useState(false);
  const handleOpenTransfer = async () => {
    await setOpenTransfer(true);
    await dispatch(clearObj());
  };
  const handleCancelTransfer = () => {
    setOpenTransfer(false);
  };

  const handleView = async (item) => {};
  const breadList = [
    {
      title: (
        <div className="flex items-center gap-[.25rem]">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
          >
            <g clipPath="url(#clip0_627_13942)">
              <path
                d="M13.7899 6.89067L7.75241 0.856289L7.34772 0.451602C7.25551 0.360003 7.13082 0.308594 7.00085 0.308594C6.87087 0.308594 6.74618 0.360003 6.65397 0.451602L0.211783 6.89067C0.117301 6.98478 0.0426296 7.09687 -0.00782254 7.22031C-0.0582747 7.34376 -0.0834854 7.47607 -0.0819665 7.60942C-0.0757165 8.15942 0.382096 8.59848 0.932096 8.59848H1.59616V13.6875H12.4055V8.59848H13.0837C13.3508 8.59848 13.6024 8.49379 13.7915 8.30473C13.8846 8.21193 13.9583 8.10159 14.0085 7.98009C14.0586 7.8586 14.0842 7.72836 14.0837 7.59692C14.0837 7.33129 13.979 7.07973 13.7899 6.89067ZM7.87585 12.5625H6.12585V9.37504H7.87585V12.5625ZM11.2805 7.47348V12.5625H8.87585V9.00004C8.87585 8.65473 8.59616 8.37504 8.25085 8.37504H5.75085C5.40553 8.37504 5.12585 8.65473 5.12585 9.00004V12.5625H2.72116V7.47348H1.22116L7.00241 1.69691L7.36335 2.05785L12.7821 7.47348H11.2805Z"
                fill="black"
                fillOpacity="0.45"
              />
            </g>
            <defs>
              <clipPath id="clip0_627_13942">
                <rect width="14" height="14" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <span>Home</span>
        </div>
      ),
      href: "/#/home",
    },
    {
      title: capitalize("Funds Transfer"),
    },
  ];

  const columns = [
    {
      title: "Created Date",
      dataIndex: "ftCreatedTime",
      render: (item) => (
        <span>{moment(item).format("Do MMM YYYY, h:mm:ss A")}</span>
      ),
      sorter: (a, b) => new Date(a.ftCreatedTime) - new Date(b.ftCreatedTime),
    },

    {
      title: "Source Name",
      dataIndex: "ftSourceWalletName",
      sorter: (a, b) =>
        a.ftSourceWalletName.localeCompare(b.ftSourceWalletName),
    },
    {
      title: "Benefitiary Acc",
      dataIndex: "ftTargetWalletName",
      sorter: (a, b) =>
        a.ftTargetWalletName.localeCompare(b.ftTargetWalletName),
    },
    {
      title: "Transfer Reason",
      dataIndex: "ftReason",
      sorter: (a, b) => a.ftReason.localeCompare(b.ftReason),
    },

    {
      title: "Amount (KES)",
      dataIndex: "ftAmount",
      render: (item) => {
        return <div>{numberWithCommas(item)}</div>;
      },
      sorter: (a, b) => a.ftAmount - b.ftAmount,
    },
    {
      title: "Request By",
      dataIndex: "ftCreatedByName",
      sorter: (a, b) => a.ftCreatedByName.localeCompare(b.ftCreatedByName),
    },

    {
      title: "Status",
      dataIndex: "ftStatus",
      render: (item) => {
        return (
          <div
            className={`${
              item === "PENDING" ? "bg-[#FFA500]" : "bg-darkGreen"
            }  text-[#FFf]  inline-block rounded-[5px] px-2 py-1 w-auto`}
          >
            {item}
          </div>
        );
      },
    },

    // {
    //   title: "Retry Transfer",
    //   render: (item) => {
    //     if (item?.ftStatus === "TRANSFERRED" || item?.ftStatus == null) {
    //       return null;
    //     }

    //     return (
    //       <button disabled={saving} onClick={() => handleConfirmation(item)}>
    //         {saving ? (
    //           <Spin className="blu_spin" />
    //         ) : (
    //           <img src={svg32} alt="svg32" />
    //         )}
    //       </button>
    //     );
    //   },
    // },
  ];

  const handleDownload = async (item) => {
    const res = await dispatch(
      downloadExcel({
        url: "api/v1/funds-transfer/export",
      })
    );
    if (res?.payload) {
      const blobData = res.payload.data;
      const headers = res.payload.headers;

      const contentType = headers["content-type"] || "application/octet-stream";
      const contentDisposition = headers["content-disposition"];

      let fileName = "funds-transfer";
      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?([^"]+)"?/);
        if (match && match[1]) {
          fileName = match[1];
        }
      }
      const blob = new Blob([blobData], { type: contentType });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();

      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);

      await toast.success(`${fileName} downloaded successfully`);
    } else {
      toast.error("Failed to download file");
    }
  };

  const [activeBtn, setActiveBtn] = useState(null);
  const today = new Date();

  const handleClick = async (item) => {
    await setActiveBtn(item);
  };

  async function fetchFundsTransferData(page, size) {
    dispatch(
      fetchFundsTransfer({
        url: "api/v1/wallet/fetch-fund-transfers",
        limit: size ?? pageSize,
        start: page ?? pageIndex,
        ftStatus: activeBtn,
        ftSourceWallet: formData?.ftSourceWallet ?? null,
      })
    );
  }

  async function fetchSettlementData() {
    dispatch(
      fetchSettlement({
        url: "api/v1/wallet/fetch-settlements",
        settlementStatus: "APPROVED",
      })
    );
  }

  useEffect(() => {
    fetchSettlementData();
  }, []);

  useEffect(() => {
    fetchFundsTransferData();
  }, [activeBtn]);

   if (loading && !openTransfer) return <CardLoading />;
  
  return (
    <div className="w-full h-full overflow-y-scroll">
      <div className="justify-between items-center white_card">
        <BreadCrumb
          breadList={breadList}
          header={"Funds Transfer"}
          info={"Here’s an overview of your Funds Transfer"}
          btn={true}
          btnTitle="Funds Transfer"
          btnSvg={flash}
          onClick={handleOpenTransfer}
        />
      </div>
      <div className="bg-white rounded-[10px] mt-[1.25rem] h-auto">
        <div className="flex flex-col w-full lg:px-10 px-3 ">
          <h3 className="font-[700] text-[24px] text-lightBlack dash-title mt-[1.25rem]">
            Funds Transfer Details
          </h3>
          <div className="mt-5 flex lg:flex-row flex-col gap-y-5 justify-between lg:items-center items-start w-full">
            <div className="flex items-center">
              <span>
                {" "}
                <button
                  onClick={showModalFilter}
                  type="button"
                  className={`bg-transparent flex items-center gap-x-'1' ${
                    Object?.keys(formData)?.length > 0
                      ? "!text-[#5688E5]"
                      : "inherit"
                  }`}
                >
                  <img src={FunnelSimple} alt="FunnelSimple" />
                  Filters
                </button>
              </span>
              {Object?.keys(formData)?.length > 0 && (
                <span className="flex items-center text-[#5688E5] cursor-pointer ml-1">
                  :{Object?.keys(formData)?.length}
                  <img src={svg38} alt="svg38" onClick={handleClearFilters} />
                </span>
              )}
            </div>
            {fundsTransfer?.length > 0 && (
              <div className="flex justify-end item-center">
                {glbLoading ? (
                  <Spin className="sms-spin" />
                ) : (
                  <Tooltip placement="top" title={"Download Excel"}>
                    <button
                      onClickopenTransfer={handleDownload}
                      className="flex items-center"
                    >
                      <MaterialIcon size={45} color="#00B050" icon="article" />
                      <span>Export to excel</span>
                    </button>
                  </Tooltip>
                )}
              </div>
            )}
          </div>

          <div className="flex items-center gap-x-14 mb-2  w-auto p-1.5">
            <button
              onClick={() => handleClick(null)}
              className={`${
                activeBtn === null
                  ? "text-[#146ADC] border border-[#146ADC]"
                  : ""
              }  !rounded-[4px]   flex items-center gap-x-5 py-1 px-5 font-[500]`}
            >
              <span className="w-[7px] h-[7px] rounded-full bg-[#146ADC]"></span>{" "}
              All
            </button>
            <button
              onClick={() => handleClick("TRANSFERRED")}
              className={`${
                activeBtn === "TRANSFERRED"
                  ? "text-[#2DD683] border border-[#2DD683]"
                  : ""
              }  !rounded-[4px]   flex items-center gap-x-5 py-1 px-5 font-[500]`}
            >
              <span className="w-[7px] h-[7px] rounded-full bg-[#2DD683]"></span>{" "}
              Transfered
            </button>

            <button
              onClick={() => handleClick("PENDING")}
              className={`${
                activeBtn === "PENDING"
                  ? "text-[#FFAB00] border border-[#FFAB00]"
                  : ""
              }  !rounded-[4px]   flex items-center gap-x-5 py-1 px-5 font-[500]`}
            >
              <span className="w-[7px] h-[7px] rounded-full bg-[#FFAB00]"></span>{" "}
              Pending
            </button>
            <button
              onClick={() => handleClick("REJECTED")}
              className={`${
                activeBtn === "REJECTED"
                  ? "text-[#9D1500] border border-[#9D1500]"
                  : ""
              }  !rounded-[4px]   flex items-center gap-x-5 py-1 px-5 font-[500]`}
            >
              <span className="w-[7px] h-[7px] rounded-full bg-[#9D1500]"></span>{" "}
              Rejected
            </button>
          </div>

          <div
            className="cursor-pointer flex items-center justify-center mt-[5px]"
            onClick={() => fetchFundsTransferData(0, 10)}
          >
            <img src={svg67} alt="svg67" />
          </div>

          <Table
            rowSelection={false}
            className="mt-[1.31rem] w-full"
            scroll={{
              x: "auto",
            }}
            rowKey={(record) => record?.ftId}
            columns={columns}
            dataSource={fundsTransfer}
            loading={loading}
            pagination={{
              position: ["bottomCenter"],
              current: pageIndex + 1,
              total: fundsTransferCount,
              pageSize: pageSize,
              onChange: (page, size) => {
                setPageIndex(page - 1);
                setPageSize(size);
                fetchFundsTransferData(page - 1, size);
              },
              showSizeChanger: false,
              hideOnSinglePage: true,
            }}
          />
        </div>
      </div>

      <FilterModal
        isModalOpen={open}
        handleCancel={handleCancel}
        formData={formData}
        setFormData={setFormData}
        filters={filters}
        setFilters={setFilters}
      />

      <TransferModal
        handleFetchData={fetchFundsTransferData}
        open={openTransfer}
        setopenSingle={setOpenTransfer}
        handleCancel={handleCancelTransfer}
      />

      <ConfirmSubmitModal
        isModalOpen={isModalOpenSubmit}
        setIsModalOpen={setIsModalOpenSubmit}
        handleSubmit={handleSubmit}
        handleCancel={handleCancelConfirmation}
        loading={saving}
        content={`Are you sure you want to retry transfer from ${prodd?.ftSourceWalletName} to ${prodd?.ftTargetWalletName} `}
      />
    </div>
  );
}

export default FundsTransferList;
